import memoize from 'memoize-one'
import shallowEqual from 'shallowequal'

import {
  SearchFilter,
  SearchFilterType,
} from 'src/chrome/FilteredSearchBar/types'

export const generateContactFilterPayload = memoize(
  (filters: SearchFilter[]) => {
    let mutableBirthdayStartDate
    let mutableBirthdayEndDate
    let mutableAnniversaryStartDate
    let mutableAnniversaryEndDate
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let mutableShowSpouseAndChildren = true
    let mutableHasNoGroup
    let mutableContacts: string[] = []
    let mutableGroups: string[] = []

    filters.forEach(filter => {
      if (
        filter.type === SearchFilterType.BOOLEAN &&
        filter.name === 'Exclude Spouse/Child'
      ) {
        if (filter.value === undefined) return
        mutableShowSpouseAndChildren = !filter.value
        return
      }

      if (
        filter.type === SearchFilterType.BOOLEAN &&
        filter.name === 'Show Unassigned'
      ) {
        if (filter.value === undefined) return
        mutableHasNoGroup = filter.value
        return
      }

      if (
        filter.type === SearchFilterType.DATERANGE &&
        filter.name === 'Anniversary'
      ) {
        if (filter.value === undefined) return
        mutableAnniversaryStartDate = filter.value.start
        mutableAnniversaryEndDate = filter.value.end
        return
      }

      if (
        filter.type === SearchFilterType.DATERANGE &&
        filter.name === 'Birthday'
      ) {
        if (filter.value === undefined) return
        mutableBirthdayStartDate = filter.value.start
        mutableBirthdayEndDate = filter.value.end
        return
      }

      if (
        filter.type === SearchFilterType.CONTACT &&
        filter.name === 'Contact'
      ) {
        if (filter.value === undefined) return
        mutableContacts = mutableContacts.concat(
          filter.value.map(contact => contact.id),
        )
        return
      }

      if (filter.type === SearchFilterType.GROUP && filter.name === 'Group') {
        if (filter.value === undefined) return
        mutableGroups = mutableGroups.concat(
          filter.value.map(contact => contact.id),
        )
        return
      }

      throw new Error(`unknown filter: ${filter.name}`)
    })

    const payload = {
      contacts: mutableContacts.length > 0 ? mutableContacts : undefined,
      groups: mutableGroups.length > 0 ? mutableGroups : undefined,
      birthdayStartDate: mutableBirthdayStartDate,
      birthdayEndDate: mutableBirthdayEndDate,
      anniversaryStartDate: mutableAnniversaryStartDate,
      anniversaryEndDate: mutableAnniversaryEndDate,
      showSecondaryContacts: mutableShowSpouseAndChildren,
      hasNoGroup: mutableHasNoGroup,
    }

    return payload
  },
  shallowEqual,
)

const COMMON_FILTERS: SearchFilter[] = [
  {
    name: 'Contact',
    type: SearchFilterType.CONTACT,
    icon: {
      svg: 'USER',
      size: 18,
      color: '#F063BD',
      viewBox: '0 0 32 32',
    },
    value: undefined,
  },
  {
    name: 'Group',
    type: SearchFilterType.GROUP,
    icon: {
      svg: 'GROUP2',
      size: 18,
      color: '#F063BD',
    },
    value: undefined,
  },
]

const CONTACT_FILTERS: SearchFilter[] = COMMON_FILTERS.concat([
  {
    name: 'Anniversary',
    type: SearchFilterType.DATERANGE,
    icon: {
      svg: 'CALENDAR',
      size: 18,
      color: '#F063BD',
      viewBox: '0 0 32 32',
    },
    value: undefined,
  },
  {
    name: 'Birthday',
    type: SearchFilterType.DATERANGE,
    icon: {
      svg: 'CALENDAR',
      size: 18,
      color: '#F063BD',
      viewBox: '0 0 32 32',
    },
    value: undefined,
  },
  {
    name: 'Exclude Spouse/Child',
    type: SearchFilterType.BOOLEAN,
    icon: {
      svg: 'CLOSECIRCLE',
      size: 20,
      color: '#F063BD',
    },
    value: undefined,
  },
  {
    name: 'Show Unassigned',
    type: SearchFilterType.BOOLEAN,
    icon: {
      svg: 'GROUP2',
      size: 18,
      color: '#F063BD',
    },
    value: undefined,
  },
])

export const DEFAULT_CONTACT_SEARCH = { filters: CONTACT_FILTERS, terms: '' }
export const DEFAULT_GROUP_SEARCH = { filters: COMMON_FILTERS, terms: '' }
